var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("examListCom.FSXQ"),
        visible: _vm.dialogVisible,
        width: "40%",
        "before-close": _vm.handleClose,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form } },
        [
          _c("el-form-item", { attrs: { label: _vm.$t("examListCom.SSMC") } }, [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(_vm._s(_vm.form.matchPlanName)),
            ]),
          ]),
          _c("el-form-item", { attrs: { label: _vm.$t("examListCom.BSLX") } }, [
            _c("div", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(
                _vm._s(
                  _vm.form.pattern === 0
                    ? _vm.$t("examListCom.TEAM")
                    : _vm.$t("examListCom.SINGLE")
                )
              ),
            ]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("examListCom.BSJZF") } },
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.form.paperStandScore)),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("examListCom.JQPFBF") } },
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.form.machineStandScore)),
              ]),
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("examListCom.RGYJBF") } },
            [
              _c("div", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(_vm._s(_vm.form.manuStandScore)),
              ]),
            ]
          ),
          _c("el-form-item", { attrs: { label: _vm.$t("examListCom.DFQK") } }, [
            _c(
              "div",
              { staticStyle: { color: "#bd1a2d", "font-weight": "bold" } },
              [
                _vm._v(
                  _vm._s(
                    `${_vm.$t("examListCom.ZDF")}${
                      _vm.form.paperScore ? _vm.form.paperScore.toFixed(2) : "-"
                    }${_vm.$t("examListCom.PQZ")}${
                      _vm.form.machineScore
                        ? _vm.form.machineScore.toFixed(2)
                        : "-"
                    }${_vm.$t("examListCom.PRG")}${
                      _vm.form.manuScore ? _vm.form.manuScore.toFixed(2) : "-"
                    }${_vm.$t("examListCom.SCORE")}`
                  )
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("examListCom.CANCEL")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("examListCom.CONFIRM")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }